import { Component, useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Header } from "./components/landing/Header";
import { Hero } from "./components/landing/Hero";
import { Marquee } from "./components/landing/Marquee";
import { Services } from "./components/landing/Services";
import { Testimonials } from "./components/landing/Testimonials";
import { QuoteSection } from "./components/landing/QuoteSection";
import { Footer } from "./components/landing/Footer";
import { FloatingWhatsApp } from "./components/landing/FloatingWhatsApp";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-ink p-8 text-center text-mist">
                    <p>Algo deu errado. Recarregue a página.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

const Landing = () => {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="grain min-h-screen bg-ink font-body text-mist">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <Testimonials />
                <QuoteSection />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
};

const App = () => (
    <ErrorBoundary>
        <Landing />
    </ErrorBoundary>
);

export default App;
